import * as BrowserWindow from '@execonline-inc/browser-window.private';
import { warn } from '@execonline-inc/logging';
import { always, assertNever, noop } from '@kofno/piper';
import { Task } from 'taskarian';
import { MissingVarError, readVarT } from '../Assertions/environments';
import ReactionComponent, { RCProps } from '../ReactionComponent';
import { State } from './States';
import { LoginStore } from './Store';

interface Props extends RCProps<LoginStore> {}

class LoginReactions extends ReactionComponent<LoginStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State): void => {
    const { store } = this.props;

    switch (state.kind) {
      case 'waiting':
        break;
      case 'redirecting':
        Task.succeed<MissingVarError | BrowserWindow.WindowInteractionError, {}>({})
          .andThen(always(readVarT('VITE_UNIFIED_LOGIN_URL')))
          .andThen(redirectToUnifiedAuthProvider)
          .fork(store.errored, noop);
        break;
      case 'errored':
        warn('Error in LoginReactions:', state.error);
        break;
      default:
        assertNever(state);
    }
  };
}

export default LoginReactions;

const redirectToUnifiedAuthProvider = BrowserWindow.Window.locationReplace;
